<template>
  <div class="page adminpage">

    <div class="app-overlay addproduct-overlay" v-if="openOverlayAddproduct">
      <div class="app-overlay-inner">
        <div class="app-overlay-close" v-on:click=" openOverlayAddproduct = false">&times;</div>
          <div class="overlay-header">
          <h2>Produkt hinzufügen</h2>
          </div>
          <div class="overlay-body">
              <add-product :products="products" @closeOverlay="openOverlayProducts = false"></add-product>
           </div>
      </div>
  </div>

    <div class="product-header">
        <div class="p-meta">
         <h1>Manager Dashboard</h1>
         <div class="actions">
           <router-link :to="{ name: 'ProductsAdmin'}"><i class="icon icon-projects"></i><span>Produkte</span></router-link>
           <router-link :to="{ name: 'ProductsAdmin'}"><i class="icon icon-user"></i><span>User</span></router-link>
         </div>
        </div>
    </div>

    <div class="columns max flex wrap productinfoedit">
        <div class="column">
          <div class="flex-group">
            <h3>Zuletzt eingepflegte Produkte</h3>
            <a v-on:click="addProduct" href="#!" class="addProduct"><i class="icon icon-plus" ></i>Produkt hinzufügen</a>
          </div>

          <div class="product-list" >
              <div class="product" v-for="(product, i) in products" :key="i" :class="product.attributes.active ? 'published' : 'unpublished'">
                <div class="pro-col product-name"><router-link :to="{ name: 'Product', params: { articlenumber: product.articlenumber }}">{{product.articlenumber}}</router-link></div>
                <div class="pro-col created">{{ product.created }}</div>
                <div class="pro-col">{{ $store.state.products.saved.success ? ( $store.state.products.saved.data.id == product.id ? ' last saved' : '') : ''  }} </div>
                <div class="pro-col"><router-link :to="{ name: 'Product', params: { articlenumber: product.articlenumber }}"><i class="icon icon-edit"></i></router-link></div>
              </div>
          </div>

        </div>
        <div class="column">
<!--           <h3>User</h3> -->
        </div>
    </div>
  </div>
</template>
<script>
  import AddProduct from '../components/AddProduct'

  export default {
    name: 'AdminPage',
    components: {
        AddProduct
    },
    data () {
      return {
        openOverlayAddproduct: false,
        newproduct: '',
        newproducterror: '',
        newproductDouble: false,
      }
    },
    computed: {
        user () {
            return this.$store.state.authentication.user
        },
        products () {
            return this.$store.state.products.all.filter( ( item, idx ) => {
              return ( idx < 30 ) 
            });
        },
    },
    created(){
        this.$store.dispatch('products/getAll');
        //console.log( this.$store.state.products.saved );
    },
    methods: {
      // checkArtNo(e){
      //       this.newproducterror = this.newproduct.length != 10
      // },
      addProduct(e){
        //console.log('addProduct');
        e.preventDefault();
        this.openOverlayAddproduct = true;
        },
      addProductSave(){

            // if( this.newproduct.length != 10 || this.newproductDouble !== false ) { this.newproducterror = true; return false }
            // 
            // this.submitted = true;
            // //this.attributes.colors = this.colors
            // //console.log(this.attributes);
            // const { id, articlenumber, attributes } = { id: null, articlenumber: this.newproduct, attributes: {} };
            // const { dispatch } = this.$store;
            // if (articlenumber && attributes) {
            //     dispatch('products/save', { id, articlenumber, attributes })
            //       .then( (res ) => {
            //           if( res.last_insert_id > 0)
            //           this.openOverlayAddproduct = false;
            //           this.$router.push('/manager/product/' + this.newproduct );
            //           //this.id = this.getSavedProduct.last_insert_id
            //       });
            // }
      },
    },
  }

</script>
<style>
  .adminpage { position: relative; padding: 9rem 0 9.88888em 0.93333em; height: 100%; min-height: 100vh; }
  .adminpage .product-header { padding: 0.93333em; }
  .adminpage .product { display: flex; border-bottom: 1px solid #454545; align-items: center; justify-content: space-between; background: transparent; transition: background 0.3s ease; }
  .adminpage .product:hover { background: rgba(255,255,255,0.1); }
  .adminpage .pro-col { padding: 0.4333em 0.4333em 0.3333em; }
  .adminpage .product a { text-decoration: none; }

  .icon-edit { background: url(/img/icons-white/edit.svg) center center no-repeat; background-size: 1.1111em; }
  .adminpage .unpublished div { opacity: 0.3; }
  .adminpage .addProduct { display: block; white-space: nowrap; padding: 0 1em 0 0; text-decoration:none;  }
  .adminpage .addProduct:hover i { transform: scale(1.04);  }
  .adminpage .addProduct i { display: inline-block; vertical-align: middle; margin-right: 0.43333em; }

  .adminpage .addproduct-overlay input { display: block; width:20em; margin: 0 auto; border-radius: 3px; padding: 0.43333em 0.93333em; text-align: center; outline: 0 !important; }  
  .adminpage input.bad { border: 3px solid #dc1200; }
  .adminpage input.good { border: 3px solid #57b200; }
  .addproduct-overlay .app-overlay-inner { text-align: center; }
  .errmess { color: #fff; display: block; width: 20em; margin: 2px auto; border-radius: 3px; line-height: 1.43333rem; height: 1.43333rem; }
  .errmess.show { background:#dc1200; }

  .adminpage .columns { padding: 0; }
  .adminpage .productinfoedit .column { padding: 0.933333em; margin: 0.93333em; background: rgba(255,255,255,0.1); border-radius: 3px;}
</style>